/**
 * Whether the search box should adopt a reconstructed Latin label for an
 * ATC-coded URL.
 *
 * - `committedLabel === null` — user cleared / reset the box; never restore.
 * - `committedLabel === ""` — cold ATC link still waiting for reconstruction.
 * - Otherwise only adopt while the input still equals what we put there, so
 *   in-progress typing is never clobbered.
 */
export function shouldAdoptResolvedLabel(
  resolvedLabel: string | null | undefined,
  committedLabel: string | null,
  searchQuery: string,
): boolean {
  if (committedLabel === null) return false;
  if (!resolvedLabel || resolvedLabel === committedLabel) return false;
  return searchQuery.trim() === committedLabel.trim();
}
